const faq = [
  {
    title: "Where are Bajaj showrooms located?",
    desc: "Ans : We have Bajaj showrooms located at Mekhri Circle, Mathikere, Yelahanka, Devanahalli, and Chikkaballapur.",
  },
  {
    title: "What are the opening hours of Bajaj showrooms?",
    desc: `Ans : Showroom Timings:<br>
    <br>• Weekdays: 9:00 AM to 6:00 PM 
    <br>• Sundays: 10:00 AM to 4:00 PM`,
  },
  {
    title: "Where are Kalyani Bajaj service centers located?",
    desc: "Ans : We have five service centers: Mekhri Circle, Mathikere, Yelahanka, Devanahalli, and Chikkaballapur.",
  },
  {
    title: "What are the opening hours of Bajaj service centers?",
    desc: `Ans : Service Center Timings:
    <br>
    <br>• Weekdays: 8:30 AM to 6:00 PM 
    <br>• Sundays: 10:00 AM to 4:00 PM`,
  },
  {
    title: "How can I book a new bike?",
    desc: `Ans : To book a vehicle, you can:
    <br>
    <br>•	Call us at 8095699900 and connect with our sales team
    <br>•	Make the payment by scanning the company’s QR code via GPay or PhonePe`,
  },
  {
    title: "What documents are required for booking a bike?",
    desc: "Ans : We require only your KYC documents to process the booking.",
  },
  {
    title: "What is the rate of interest for a two-wheeler loan?",
    desc: "Ans : The rate of interest starts at 8%, and the final rate depends on your individual profile.",
  },
  {
    title: "How many days does the loan process take?",
    desc: "Ans : If all documents and profile criteria are met, the loan can be processed within an hour.",
  },
  {
    title: "Is it safe to transfer the payment via GPay?",
    desc: "Ans : Payments can be made by scanning the company's QR code and adding the company details through your preferred payment app.",
  },
  {
    title: "Which Bajaj models are the fastest-selling?",
    desc: "Ans : Most Bajaj bikes are fast-moving models, popular among customers based on their preferences—whether it's for mileage and budget, or sports and cruiser segments.",
  },
  {
    title: "How do Bajaj models compare to others in terms of quality?",
    desc: "Ans : Bajaj models are a great choice for individual buyers, offering powerful performance, low maintenance, and excellent mileage.",
  },
  {
    title:
      "What are the unique features of Bajaj 110cc models compared to other brands?",
    desc: `Ans :  One key feature that sets Bajaj 110cc models apart is the <b>Twin Spark technology</b>, which is implemented in all our motorcycles above 110cc.`,
  },
];

const testimonials = [
  {
    user: "Ruchi Prayana",
    desc: "Positive: Professionalism, quality,Value My overall experience for Bike mechanic was really good and satisfying. The service I got was very polite and helpful. One who require genuine service should definitely go and visit Banashankari Bajaj Service for the best. All the technician all great helpfull. The technician shreyas was very helpful. Thank Bajaj Banashankari",
  },
  {
    user: "PAVAN",
    desc: "Highly interactive technicians, good service. My Pulser200 has coolent oil leakage problem form past 6months... Some one sugested Banashankari service station. After visiting many Bajaj service center. Finally the problem has been cleared by visiting just once to Banashankari Bajaj service center. Thanks for technicians there, majorly thanks to shreys (technician).",
  },
  {
    user: "Vikas V",
    desc: "Good service and friendly guys. They explain the problem and solve it. Vijay is very helpful. Any query about the bike anytime, he picks the calls and helps out.",
  },
  {
    user: "Manisuriya Suriya",
    desc: "Good response from sales team , Saturday I visited the showroom to enquiry even they offered for test drive , so I refer to visit the showesho for the customers best service ever .",
  },
  {
    user: "Yashvanth Vk",
    desc: "There was gud response from the term , and I refer customers to visit to the showroom .my brother took  the bike  they gave with registration  and ful documents , if you are planing to to buy  u guys sould visit Bajaj Banashankari  for the gud response.",
  },
  {
    user: "Lakshminarayanan Munesh",
    desc: "I'm new to the Bajaj family. I have got the first service done in this service center. Senior technician Mr Manju is very knowledgeable, did a great job with the bike. They also let you in to see the service process. Overall it's a very good place for your Bajaj service.",
  },
  {
    user: "Shreyas MB",
    desc: "I got my Pulser390 serviced on Saturday 14th August and the bike was delivered as promised on the same day and all my requests were attended and I could see the difference after service to before. Also Shreyas was the person who took the service request and he lived up to my expectation, also as promised he even called me today to inform me about software update. I definitely recommend this place for other Bajaj lovers to visit for servicing their Bajaj bikes.",
  },
  {
    user: "Harshavardhana S G",
    desc: "Bajaj is love ❤️. So Bajaj showroom is also a lovely place. Vry good staff is available here. Good customer satisfaction is given to each and every customer. Vry good service of the bike is done here. All the problems are solved without any hassles.",
  },
  {
    user: "Madan Raj",
    desc: "Good service, Mr Mahesh is definitely among the best & honest technician I have seen so far.. Even sales team ks good with their knowledge and customer gesture.. I suggest anyone to contact them before taking their bike for service as they would be busy most of the time..",
  },
  {
    user: "Aggit Kurian",
    desc: "Amazing experience in Bajaj showroom, nice and caring.  Well trained people's are use to service bikes in this place.",
  },
  {
    user: "Jagadish Kumar",
    desc: "Excellent customer satisfaction both in sales as well as service.Kindly head down here for any enquiries as well as test drives and quotations.Good service by sales team by offering a variety of finance schemes and after sales support",
  },
  {
    user: "Kiran Robert",
    desc: "From past 4 years I service my Bajaj Pulserhere, it's always a wonderful experience, special thanks to Venkatesh for all the support💪 Like",
  },
  {
    user: "Vinod Chandra",
    desc: "Good one for service of Bajaj bike I just done with Bajaj Pulser200 service pretty good they have done the service.",
  },
  {
    user: "Naveen Pradeep Pandurangan",
    desc: "I've always got my Pulser390 serviced from here. They do a really good job and the staff are courteous and listen to your problem and put best efforts in solving the problem. Thank you guys keep up the good work!!!",
  },
  {
    user: "Sreedhar Sree",
    desc: "Satisfied with the service and the response to customers. Met Mr. venkatesh, who has taken my Adv 390 for service. Thanks alot team.",
  },
];

const reviews = [
  {
    user: "Ruchi Prayana",
    raiting: 5,
    desc: "Positive: Professionalism, quality,Value My overall experience for Bike mechanic was really good and satisfying. The service I got was very polite and helpful. One who require genuine service should definitely go and visit Banashankari Bajaj Service for the best. All the technician all great helpfull. The technician shreyas was very helpful. Thank Bajaj Banashankari",
    location: "Bajaj Banashankari",
  },
  {
    user: "PAVAN",
    raiting: 5,
    desc: "Highly interactive technicians, good service. My Pulser200 has coolent oil leakage problem form past 6months... Some one sugested Banashankari service station. After visiting many Bajaj service center. Finally the problem has been cleared by visiting just once to Banashankari Bajaj service center. Thanks for technicians there, majorly thanks to shreys (technician).",
    location: "Bajaj Banashankari",
  },
  {
    user: "Vikas V",
    raiting: 5,
    desc: "Good service and friendly guys. They explain the problem and solve it. Vijay is very helpful. Any query about the bike anytime, he picks the calls and helps out.",
    location: "Bajaj Banashankari",
  },
  {
    user: "Manisuriya Suriya",
    raiting: 5,
    desc: "Good response from sales team , Saturday I visited the showroom to enquiry even they offered for test drive , so I refer to visit the showesho for the customers best service ever .",
    location: "Bajaj Banashankari",
  },
  {
    user: "Yashvanth Vk",
    raiting: 5,
    desc: "There was gud response from the term , and I refer customers to visit to the showroom .my brother took  the bike  they gave with registration  and ful documents , if you are planing to to buy  u guys sould visit Bajaj Banashankari  for the gud response.",
    location: "Bajaj Banashankari",
  },
  {
    user: "Lakshminarayanan Munesh",
    raiting: 5,
    desc: "I'm new to the Bajaj family. I have got the first service done in this service center. Senior technician Mr Manju is very knowledgeable, did a great job with the bike. They also let you in to see the service process. Overall it's a very good place for your Bajaj service.",
    location: "Bajaj Kengeri",
  },
  {
    user: "Shreyas MB",
    raiting: 5,
    desc: "I got my Pulser390 serviced on Saturday 14th August and the bike was delivered as promised on the same day and all my requests were attended and I could see the difference after service to before. Also Shreyas was the person who took the service request and he lived up to my expectation, also as promised he even called me today to inform me about software update. I definitely recommend this place for other Bajaj lovers to visit for servicing their Bajaj bikes.",
    location: "Bajaj Kengeri",
  },
  {
    user: "Harshavardhana S G",
    raiting: 5,
    desc: "Bajaj is love ❤️. So Bajaj showroom is also a lovely place. Vry good staff is available here. Good customer satisfaction is given to each and every customer. Vry good service of the bike is done here. All the problems are solved without any hassles.",
    location: "Bajaj Kengeri",
  },
  {
    user: "Madan Raj",
    raiting: 5,
    desc: "Good service, Mr Mahesh is definitely among the best & honest technician I have seen so far.. Even sales team ks good with their knowledge and customer gesture.. I suggest anyone to contact them before taking their bike for service as they would be busy most of the time..",
    location: "Bajaj Kengeri",
  },
  {
    user: "Aggit Kurian",
    raiting: 5,
    desc: "Amazing experience in Bajaj showroom, nice and caring.  Well trained people's are use to service bikes in this place.",
    location: "Bajaj Kengeri",
  },
  {
    user: "Jagadish Kumar",
    raiting: 5,
    desc: "Excellent customer satisfaction both in sales as well as service.Kindly head down here for any enquiries as well as test drives and quotations.Good service by sales team by offering a variety of finance schemes and after sales support",
    location: "Bajaj Yelahanka",
  },
  {
    user: "Kiran Robert",
    raiting: 5,
    desc: "From past 4 years I service my Bajaj Pulserhere, it's always a wonderful experience, special thanks to Venkatesh for all the support💪 Like",
    location: "Bajaj Yelahanka",
  },
  {
    user: "Vinod Chandra",
    raiting: 5,
    desc: "Good one for service of Bajaj bike I just done with Bajaj Pulser200 service pretty good they have done the service.",
    location: "Bajaj Yelahanka",
  },
  {
    user: "Naveen Pradeep Pandurangan",
    raiting: 5,
    desc: "I've always got my Pulser390 serviced from here. They do a really good job and the staff are courteous and listen to your problem and put best efforts in solving the problem. Thank you guys keep up the good work!!!",
    location: "Bajaj Yelahanka",
  },
  {
    user: "Sreedhar Sree",
    raiting: 5,
    desc: "Satisfied with the service and the response to customers. Met Mr. venkatesh, who has taken my Adv 390 for service. Thanks alot team.",
    location: "Bajaj Yelahanka",
  },
];

export { faq, testimonials, reviews };
